module.exports = "/images/vendor/desiigner-svg/svg/ui/on-air.svg?8b680f34b5b9ccdcf13eab6476b8e7f9";